<div *ngIf="addresses.length > 0 || searching || postcodeAddresses.length > 0" class="border rounded mt-1 mb-3" style="max-height: 300px; overflow-y: auto;">

  <div *ngIf="searching" class="d-flex justify-content-center p-3">
    <div class="spinner-border spinner-border-sm text-success" role="status">
      <span class="visually-hidden">Searching...</span>
    </div>
  </div>

  <div *ngIf="addresses.length > 0" class="list-group list-group-flush">
    <a *ngFor="let address of addresses"
       class="list-group-item list-group-item-action small"
       style="cursor: pointer;"
       (click)="select(address.id)">
      {{address.building_Name + address.number + ' ' + address.street + ', ' + address.addressLine2 + ', ' + address.addressLine3 + ', ' + address.addressLine4 + ', ' + address.addressLine5}}
    </a>
  </div>

  <div *ngIf="postcodeAddresses.length > 0" class="list-group list-group-flush">
    <a *ngFor="let address of postcodeAddresses"
       class="list-group-item list-group-item-action small"
       style="cursor: pointer;"
       (click)="selectPostcode(address)">
      {{address.building_Name + address.number + ' ' + address.street + ', ' + address.addressLine2 + ', ' + address.addressLine3 + ', ' + address.addressLine4 + ', ' + address.addressLine5}}
    </a>
  </div>

</div>